/* @flow */
import * as React from 'react';

import NavigationService from 'services/NavigationService';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator';
import * as emailDomainsPermissions from 'permissions/emailDomains';
import TableButton from 'components/TableButton';
import { actionDrawerStore } from 'services/ServiceRegistry';

import createReportView from '../components/ReportView/ReportViewBase';
import type { ViewConfig, DataViewColumn } from '../components/ReportView/types';

const columns: DataViewColumn[] = [
  {
    columnName: 'domain',
    title: 'general:email_domains.labels.domain_plural',
    flexBasis: 1,
  },
  {
    columnName: 'is_disabled',
    title: 'general:email_domains.labels.status',
    flexBasis: 120,
    noFlexGrow: true,
    component: function DomainStatusCell({ display }) {
      return <StatusIndicator status={display ? 'disabled' : 'enabled'} />;
    },
  },
  {
    columnName: 'id',
    title: '',
    flexBasis: 80,
    noFlexGrow: true,
    disableSort: true,
    component: function EditButtonCell({ rowData }) {
      const handleEditButtonClick = () => {
        setImmediate(() => {
          NavigationService.navigateTo('email-domains/edit', rowData);
        });
      };

      return <TableButton label="Edit" iconHref="#icon-edit" onClick={handleEditButtonClick} />;
    },
  },
  {
    columnName: 'id',
    title: '',
    flexBasis: 100,
    noFlexGrow: true,
    disableSort: true,
    component: function DeleteButtonCell({ rowData }) {
      const handleRemoveButtonClick = () => {
        setImmediate(() => {
          actionDrawerStore.openActionDrawer('deleteEmailDomain', {
            emailDomainToDeleteId: rowData.id,
          });
        });
      };

      return <TableButton label="Remove" iconHref="#icon-bin" onClick={handleRemoveButtonClick} />;
    },
  },
];

const viewConfig: ViewConfig = {
  title: 'general:email_domains.title',
  codename: 'email-domains',
  type: 'SINGLE',
  userFilterNamespace: 'blocked-email-domains',
  view: {
    dataPathname: 'blocked-email-domains',
    apiType: 'SQL',
    columns,
  },
  buttons: [
    {
      label: 'New',
      icon: '#icon-add',
      to: '/email-domains/create',
      permissions: emailDomainsPermissions.create,
    },
  ],
};

export default createReportView(viewConfig);
